'use strict';

function Countdown() {
  this.id = null;
  this.node = null;
  this.declaredClass = null;

  this.el = {};
  this._classes = {
    countdownDays: 'js--countdown-days',
    countdownHours: 'js--countdown-hours',
    countdownMinutes: 'js--countdown-minutes'
  };

  this.init = function () {
    this.el.$countdownDays = $('.' + this._classes.countdownDays);
    this.el.$countdownHours = $('.' + this._classes.countdownHours);
    this.el.$countdownMinutes = $('.' + this._classes.countdownMinutes);

    this._countDown();
  };

  this.initAllReady = function () {};
  // TODO: maybe this can be a component where you can pass starting date and ending date for a countdown.. or we can just use moment-countdown add-on ¯\_(ツ)_/¯
  this._countDown = function () {
    var interval = 1000;

    var $days = this.el.$countdownDays;
    var $hours = this.el.$countdownHours;
    var $minutes = this.el.$countdownMinutes;

    setInterval(function () {
      var eventTime = moment().tz('America/Vancouver').endOf('month').unix();
      var currentTime = moment().tz('America/Vancouver').unix();

      // 1522566000 is the unix time for april 1st 0hr 0m 0secs
      // which is the last day of the draw
      if (currentTime >= 1522566000) {
        $days.text('00');
        $hours.text('00');
        $minutes.text('00');
      } else {
        var diffTime = eventTime - currentTime;
        var duration = moment.duration(diffTime * 1000, 'milliseconds');

        duration = moment.duration(duration.asMilliseconds() - interval, 'milliseconds');

        var d = moment.duration(duration).days();
        var h = moment.duration(duration).hours();
        var m = moment.duration(duration).minutes();

        d = $.trim(d).length === 1 ? '0' + d : d;
        h = $.trim(h).length === 1 ? '0' + h : h;
        m = $.trim(m).length === 1 ? '0' + m : m;

        $days.text(d);
        $hours.text(h);
        $minutes.text(m);
      }
    }, interval);
  };
}